var o = (r, s, t) => new Promise((n, i) => {
  var u = (e) => {
    try {
      a(t.next(e));
    } catch (c) {
      i(c);
    }
  }, p = (e) => {
    try {
      a(t.throw(e));
    } catch (c) {
      i(c);
    }
  }, a = (e) => e.done ? n(e.value) : Promise.resolve(e.value).then(u, p);
  a((t = t.apply(r, s)).next());
});
import { selfAxios as f } from "@oppein/op-utils";
function m(r) {
  return o(this, null, function* () {
    const {
      data: s
    } = yield f.post(
      "/unifiedcheck/universalCheckApi/requestCheckByParams",
      r
    );
    return s == null ? void 0 : s.data;
  });
}
export {
  m as postRequestCheckByParams
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/unifiedcheck/universalCheckApi/requestCheckByParams/post.js
// module id = 955
// module chunks = 41